// Mixcloud shows from https://www.mixcloud.com/djmastafive/
// Fetched via Mixcloud public API: https://api.mixcloud.com/djmastafive/cloudcasts/

export const mixcloudProfile = {
  username: "djmastafive",
  profileUrl: "https://www.mixcloud.com/djmastafive/"
};

export const mixcloudShows = [
  {
    name: "AFRO HOUSE MIX live @ SPOT ON festival 17 may 2025",
    key: "/djmastafive/afro-house-mix-live-spot-on-festival-17-may-2025/",
    url: "https://www.mixcloud.com/djmastafive/afro-house-mix-live-spot-on-festival-17-may-2025/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/profile/e/b/d/a/58ca-7c4d-4456-86bf-4dd974467153",
    created: "2025-05-19T20:50:12Z",
    duration: 4052
  },
  {
    name: "DJ MASTAFIVE Party Joynts! 31-10-2024",
    key: "/djmastafive/dj-mastafive-20241004-210658/",
    url: "https://www.mixcloud.com/djmastafive/dj-mastafive-20241004-210658/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/profile/e/b/d/a/58ca-7c4d-4456-86bf-4dd974467153",
    created: "2024-11-28T02:26:16Z",
    duration: 10229
  },
  {
    name: "NU FUNK DISCO - Live Mixed 13-4-2024",
    key: "/djmastafive/nu-funk-disco-live-mixed-11-4-2024/",
    url: "https://www.mixcloud.com/djmastafive/nu-funk-disco-live-mixed-11-4-2024/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/9/4/5/d/87b5-6701-49e7-9cfb-8b1f20b47d77",
    created: "2024-04-15T02:29:33Z",
    duration: 4019
  },
  {
    name: "FELL GODD TO LIMONADE - GORILLAZ vs Internet Money - Mastafive MASHUP",
    key: "/djmastafive/fell-godd-to-limonade-gorillaz-vs-internet-money-mastafive-mashup/",
    url: "https://www.mixcloud.com/djmastafive/fell-godd-to-limonade-gorillaz-vs-internet-money-mastafive-mashup/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/f/4/e/0/77ac-686f-4930-899a-08ff8e5a21e7",
    created: "2024-01-25T13:15:56Z",
    duration: 248
  },
  {
    name: "DJ Mastafive Live @ WHIRPOOL ROOM - Blonde Brothers 31-7-2020",
    key: "/djmastafive/dj-mastafive-live-whirpool-room-blonde-brothers-27-7-2022/",
    url: "https://www.mixcloud.com/djmastafive/dj-mastafive-live-whirpool-room-blonde-brothers-27-7-2022/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/7/1/2/7/b2c1-5ca0-4465-96c8-191e6902cccb",
    created: "2023-07-28T16:00:00Z",
    duration: 8252
  },
  {
    name: "DJ MASTAFIVE dj set live @whirpool ROOM @ Blonde Brothers 19-9-2020",
    key: "/djmastafive/dj-mastafive-dj-set-live-whirpool-room-blonde-brothers-19-9-2020/",
    url: "https://www.mixcloud.com/djmastafive/dj-mastafive-dj-set-live-whirpool-room-blonde-brothers-19-9-2020/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/4/f/a/a/2f77-fc23-4a43-b62b-0f637325dbc2",
    created: "2023-07-27T23:55:40Z",
    duration: 11443
  },
  {
    name: "WE GOT FLAVA ospite FFIUME",
    key: "/djmastafive/we-got-flava-ospite-ffiume/",
    url: "https://www.mixcloud.com/djmastafive/we-got-flava-ospite-ffiume/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/c/8/c/d/3070-ea07-4744-80a6-ec56954be21f",
    created: "2023-07-20T19:30:00Z",
    duration: 3724
  },
  {
    name: "WE GOT FLAVA ospite SKLERO",
    key: "/djmastafive/we-got-flava-ospite-sklero/",
    url: "https://www.mixcloud.com/djmastafive/we-got-flava-ospite-sklero/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/3/a/6/5/c233-0eab-45f3-8617-4e283120b69d",
    created: "2023-07-11T21:42:42Z",
    duration: 4128
  },
  {
    name: "WE GOT FLAVA ospite COLLE DER FOMENTO",
    key: "/djmastafive/we-got-flava-ospite-colle-der-fomento/",
    url: "https://www.mixcloud.com/djmastafive/we-got-flava-ospite-colle-der-fomento/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/8/5/9/6/3d63-2729-46e7-ba40-a87e4608bcbf",
    created: "2023-07-05T13:54:50Z",
    duration: 6742
  },
  {
    name: "WE GOT FLAVA ospite PIOTTA",
    key: "/djmastafive/we-got-flava-ospite-piotta/",
    url: "https://www.mixcloud.com/djmastafive/we-got-flava-ospite-piotta/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/6/9/9/e/a3d9-b7a3-4cbb-9274-b88c84075eba",
    created: "2023-06-21T00:17:11Z",
    duration: 4360
  },
  {
    name: "WE GOT FLAVA ospite AME2.0 e Rakno",
    key: "/djmastafive/we-got-flava-ospite-ame20-e-rakno/",
    url: "https://www.mixcloud.com/djmastafive/we-got-flava-ospite-ame20-e-rakno/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/0/e/6/0/b889-8e68-4f63-930f-ec3e1968809a",
    created: "2023-06-15T19:00:56Z",
    duration: 4710
  },
  {
    name: "WE GOT FLAVA ospite DJ SHOCCA",
    key: "/djmastafive/we-got-flava-ospite-dj-shocca/",
    url: "https://www.mixcloud.com/djmastafive/we-got-flava-ospite-dj-shocca/",
    pic: "https://thumbnailer.mixcloud.com/unsafe/600x600/extaudio/e/0/c/6/b1fa-e33d-463f-9a63-ab899b430985",
    created: "2023-06-08T21:21:35Z",
    duration: 4734
  }
];

export function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return "";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function formatShowDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

export function mixcloudEmbedUrl(key, { autoplay = true, hideCover = false, light = true } = {}) {
  const params = new URLSearchParams();
  params.set("feed", key);
  if (autoplay) params.set("autoplay", "1");
  if (hideCover) params.set("hide_cover", "1");
  if (light) params.set("light", "1");
  return `https://player-widget.mixcloud.com/widget/iframe/?${params.toString()}`;
}
